/**
 * Parse what someone has typed into a numeric field.
 *
 * Returns `null` for anything that is not yet a number — including the
 * half-typed states a person passes through on the way to one ("", "-", "12.").
 * The caller keeps the raw text; only the committed value goes through here.
 *
 * The bug this exists to prevent: calling `parseFloat` on every keystroke and
 * storing the result as the input's value. `parseFloat('12.')` is `12`, so the
 * decimal point is erased the instant it is typed and no decimal can ever be
 * entered. That shipped in the race-data correction dialog and in three event
 * forms, on fields that are almost entirely decimals.
 */
export function parseNumeric(raw: string, integer = false): number | null {
  const trimmed = raw.trim();
  if (trimmed === '') return null;
  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) return null;
  return integer ? Math.trunc(parsed) : parsed;
}

/** Format a stored number for display in a text input. */
export function formatNumeric(value: number | null | undefined): string {
  return value === null || value === undefined ? '' : String(value);
}

/** Currency for table cells. `null` renders as an em dash, not "$0.00". */
export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return `$${value.toFixed(2)}`;
}
